import React, { useCallback, useEffect, useRef, useState } from 'react';

import Grid from '@mui/material/Grid2';

import {
  Character,
  CharacterFeature,
  SpellsFromList,
} from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";
import CharacterListOptionsInput from "@dndComponents/character/misc/CharacterListOptionsInput";

interface Props {
  character: Character;
  char_feature: CharacterFeature;
  onChange: () => void;
}

const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterSpellsFromListInput({ 
  character,
  char_feature,
  onChange
}: Props) {
  const sfl = char_feature.floating_feature as SpellsFromList;
  const [fetched, setFetched] = useState(false);
  const [spell_ids, setSpellIds] = useState(char_feature.feature_options as string[]);
  const [select_changed, setSelectChanged] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [count, setCount] = useState(0);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const recalculated = useCallback(() => {
    setReloading(true);
  }, [setReloading]);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      const new_count = char_util.value(sfl.count, { obj: character, source_id: char_feature.source_true_id });
      setCount(new_count);
      character.subscription_holder.subscribe("Recalculated", mounted, recalculated);
    }
  }, [character, fetched, setFetched, mounted, recalculated, sfl, char_feature]);
  
  useEffect(() => {
    if (select_changed) {
      setSelectChanged(false);
      // debugger;
      const use_me: string[] = [];
      for (let i = 0; i < count; ++i) {
        if (spell_ids[i]) {
          use_me.push(spell_ids[i]);
        } else {
          use_me.push("");
        }
      }
      char_feature.feature_options = use_me;
      character.changed();
      character.subscription_holder.recalculate();
    }
  }, [character, char_feature, spell_ids, select_changed, setSelectChanged, count]);


  if (sfl.spell_limit.use_selectable) {
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          className="header centered"
          size={{
            xs: 12
          }}>
          { sfl.name }
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <DisplayStringWithReplacements display_string={ sfl.description } cfs={character} />
        </Grid>
      </Grid>
    );
  } else {
    const limit = sfl.spell_limit.clone();
    const use_spells = char_util.getSpellsForLimit({ char: character, limit });
    // console.log(char_feature);
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          className="header centered"
          size={{
            xs: 12
          }}>
          { sfl.name }
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <DisplayStringWithReplacements display_string={ sfl.description } cfs={character} />
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <CharacterListOptionsInput
            data_type="spell"
            character={character}
            choose_max={count} 
            use_objects={use_spells}
            selected={spell_ids.filter(o => o !== "")} 
            // selected_elsewhere={character.mind.spells.filter(o => !spell_ids.includes(o.spell_id)).map(o => o.spell_id)} 
            onChange={(changed: string[]) => {
              setSpellIds(changed);
              setSelectChanged(true);
            }} 
          />
        </Grid>
      </Grid>
    );
  }
}
